import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import "../styles/Home.css";
import TechlynxHero, { TechlynxBrandEnd } from "../components/home/TechlynxHero";
import HomeVideoCarousel from "../components/home/HomeVideoCarousel";
import AppDevelopmentProcess from "../components/AppDevelopmentProcess/AppDevelopmentProcess";
import i from "../assets/3i Infotech.webp";
import al from "../assets/Alphalogic Tech.webp";
import bi from "../assets/Birla soft.webp";
import ca from "../assets/Capgemeni.webp";
import cap from "../assets/Capillary Tech.webp";
import co from "../assets/Covance Softsol.webp";
import cs from "../assets/CSM Technologies.webp";
import hc from "../assets/HCL.webp";
import he from "../assets/Hexaware technologies.webp";
import hy from "../assets/Hypersoft Tech.webp";
import inf from "../assets/InfoBeans Tech.webp";
import kp from "../assets/KPIT.webp";
import kpm from "../assets/KPMG.webp";
import sa from "../assets/Saksoft.webp";
import sh from "../assets/Shradha AI Tech.webp";
import so from "../assets/Softtech Enginee.webp";
import tc from "../assets/TCS.webp";
import te from "../assets/Tech mahindra.webp";
import tr from "../assets/Trigyn Techno.webp";
import wn from "../assets/WNS.webp";
import ya from "../assets/yash technologies.webp";
import ze from "../assets/Zensar.webp";



const faqs = [
  ["What does Techlynx Innovations do?", "Techlynx brings software engineering, AI and data, cloud and DevOps, security and QA, enterprise technology, design and business services together under one technology partner."],
  ["Can you build a product from idea to deployment?", "Yes. Our delivery model can cover discovery, architecture, UI/UX, engineering, APIs, databases, testing, cloud deployment and post-launch improvement."],
  ["Do you provide training as well as services?", "Yes. The Techlynx portfolio includes technology and professional training across software development, AI, data, cloud, testing, security, design and business domains."],
  ["Can you integrate AI into an existing business system?", "Yes. AI can be introduced through APIs, RAG pipelines, automation, analytics, document intelligence, chat interfaces and workflow-specific models."],
  ["Do you work with startups and established businesses?", "Our service portfolio is designed to support both new digital products and existing organisations modernising their technology landscape."],
  ["How can students apply for an internship at Techlynx Innovations? ","Students can apply through our internship or careers section by submitting their resume and required details. Selected candidates may be contacted for an assessment or interview based on the internship role and eligibility criteria. "],
  ["Do Techlynx internships provide practical project experience? ","Yes. Our internship programs are designed to provide hands-on exposure through real-world projects, technical tasks, teamwork, and mentorship. The exact responsibilities depend on the selected domain and internship role. "],
  ["How can I apply for a job at Techlynx Innovations? ","You can apply for available positions through our careers section or submit your profile to our recruitment team. Our team reviews applications based on the role's requirements, skills, qualifications, and experience. "],
  ["What services does Techlynx Innovations provide to clients? ","Techlynx Innovations provides technology solutions across areas such as software development, web and application development, AI solutions, automation, cloud technologies, data intelligence, and cyber Security. We can also discuss customized solutions based on a client's specific requirements. "],
  ["How can a client start a project with Techlynx Innovations? ","Clients can contact our team through the website's contact section and share their requirements, goals, and expected timeline. Our team will discuss the project, suggest an appropriate solution, and guide you through the next steps. "]
];

function Reveal({ children, className = "", delay = 0 }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { el.classList.add("is-visible"); io.unobserve(el); }
    }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <div ref={ref} style={{ "--delay": `${delay}ms` }} className={`reveal ${className}`}>{children}</div>;
}

function TestimonialsExperience({ active, setActive }) {
  const items = [
    { id:"01", quote:"A technology partner should reduce complexity, not create it. Techlynx approaches the problem from the business outcome backwards.", role:"Technology Leadership", client:"Enterprise Client", signal:"CLARITY", detail:"Business outcome → architecture → execution" },
    { id:"02", quote:"The strongest part of the engagement was the ability to connect product thinking, engineering and automation in one roadmap.", role:"Business Operations", client:"Growth Client", signal:"CONNECTION", detail:"Product → engineering → automation" },
    { id:"03", quote:"From the first discovery conversation to delivery, the focus stayed on building something useful, scalable and measurable.", role:"Product Team", client:"Digital Client", signal:"MOMENTUM", detail:"Discovery → delivery → measurable impact" },
  ];
  const item = items[active % items.length];
  return <section className="testimonial-experience section-pad" id="testimonials">
    <div className="testimonial-top"><div><h2>Built to earn <span>trust</span></h2></div><p className="testimonial-intro">A good technology relationship is measured in clarity, responsiveness and what becomes possible after launch.</p></div>
    <div className="testimonial-stage">
      <div className="testimonial-visual" aria-hidden="true"><div className="testimonial-grid"/><div className="testimonial-orbit to-a"/><div className="testimonial-orbit to-b"/>{[0,1,2,3,4,5,6,7].map(i=><i key={i} className={`testimonial-particle tp-${i}`} />)}<div className="testimonial-core"><small>TRUST SIGNAL</small><strong>{item.signal}</strong><span>TECHLYNX / 0{item.id}</span></div><div className="testimonial-readout"><span>RELATIONSHIP</span><b>ACTIVE</b><em>{item.detail}</em></div></div>
      <article className="testimonial-story" key={item.id}><div className="testimonial-index"><span>{item.id}</span><i/><span>03</span></div><blockquote>“{item.quote}”</blockquote><div className="testimonial-person"><div className="testimonial-avatar">{item.client.slice(0,1)}</div><div><strong>{item.role}</strong><span>{item.client}</span></div></div><div className="testimonial-controls"><button onClick={()=>setActive((active+2)%3)} aria-label="Previous testimonial">←</button><div>{items.map((_,i)=><button key={i} className={i===active?'active':''} onClick={()=>setActive(i)} aria-label={`Testimonial ${i+1}`}><span/></button>)}</div><button onClick={()=>setActive((active+1)%3)} aria-label="Next testimonial">→</button></div></article>
    </div>
  </section>;
}

function Counter({ value, suffix = "+" }) {
  const [num, setNum] = useState(0); const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      let start = 0; const end = value; const t0 = performance.now();
      const step = t => { const p = Math.min((t - t0) / 1500, 1); start = Math.round(end * (1 - Math.pow(1 - p, 3))); setNum(start); if (p < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step); io.disconnect();
    }, { threshold: .5 });
    if (ref.current) io.observe(ref.current); return () => io.disconnect();
  }, [value]);
  return <span ref={ref}>{num}{suffix}</span>;
}

function WhoWeAreExperience() {
  const sectionRef = useRef(null);
  const leftRefs = useRef([]);
  const rightRefs = useRef([]);
  const particleRefs = useRef([]);

  const images = [
    { title: "SOFTWARE", subtitle: "ENGINEERING", image: "/11.png" },
    { title: "ARTIFICIAL", subtitle: "INTELLIGENCE", image: "/222.png" },
    { title: "DATA", subtitle: "INTELLIGENCE", image: "/33.png" },
    { title: "CLOUD", subtitle: "INFRASTRUCTURE", image: "/44.png" },
    { title: "AUTOMATION", subtitle: "WORKFLOW", image: "/55.png" },
    { title: "SECURITY", subtitle: "TRUST", image: "/666.png" },
  ];

  const particles = useRef(
    images.map((_, cardIndex) =>
      Array.from({ length: 32 }, (_, index) => ({
        x: (((index * 47 + cardIndex * 71) % 101) - 50) * 1.35,
        y: (((index * 83 + cardIndex * 37) % 101) - 50) * 1.1,
        size: 1.5 + ((index * 13 + cardIndex * 7) % 18) / 10,
        opacity: 0.35 + ((index * 17) % 60) / 100,
      }))
    )
  ).current;

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    let raf = 0;
    let target = 0;
    let smooth = 0;

    const clamp = (value) => Math.min(1, Math.max(0, value));
    const ease = (value) => value * value * (3 - 2 * value);

    const readScroll = () => {
      const rect = section.getBoundingClientRect();
      target = clamp(
        -rect.top / Math.max(1, rect.height - window.innerHeight)
      );
      if (!raf) raf = requestAnimationFrame(render);
    };

    const render = () => {
      raf = 0;
      smooth += (target - smooth) * 0.075;

      const starts = [0, 0.18, 0.36];
      const ends = [0.52, 0.72, 0.94];
      const travelX = [3, 5, 7];
      const travelY = [0, 2.5, 5];

      const cardProgress = (index) =>
        ease(clamp((smooth - starts[index]) / Math.max(0.001, ends[index] - starts[index])));

      const updateCard = (card, index, side) => {
        if (!card) return;

        const p = cardProgress(index);
        const direction = side === "left" ? -1 : 1;
        const rotation = side === "left" ? -20 : 20;
        const globalIndex = side === "left" ? index : index + 3;

        card.style.transform =
          `translate3d(${direction * travelX[index]}vw, ${travelY[index]}vh, 0) rotate(${rotation * p}deg)`;
        card.style.transform =
          `translate3d(${direction * travelX[index] * p}vw, ${travelY[index] * p}vh, 0) rotate(${rotation * p}deg)`;

        const particlesForCard = particleRefs.current[globalIndex] || [];
        particlesForCard.forEach((particle, particleIndex) => {
          if (!particle) return;
          const data = particles[globalIndex][particleIndex];
          particle.style.transform =
            `translate3d(${data.x * p}px, ${data.y * p}px, 0) scale(${1 - p * 0.55})`;
          particle.style.opacity = (p * data.opacity).toFixed(3);
        });
      };

      leftRefs.current.forEach((card, index) => updateCard(card, index, "left"));
      rightRefs.current.forEach((card, index) => updateCard(card, index, "right"));

      section.style.setProperty("--who-progress", smooth.toFixed(4));

      if (Math.abs(target - smooth) > 0.0003) {
        raf = requestAnimationFrame(render);
      }
    };

    readScroll();
    window.addEventListener("scroll", readScroll, { passive: true });
    window.addEventListener("resize", readScroll);

    return () => {
      window.removeEventListener("scroll", readScroll);
      window.removeEventListener("resize", readScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [particles]);

  const renderCard = (item, index, side) => {
    const globalIndex = side === "left" ? index : index + 3;

    return (
      <div
        key={`${side}-${item.title}`}
        ref={(element) => {
          if (side === "left") leftRefs.current[index] = element;
          else rightRefs.current[index] = element;
        }}
        className={`who-fix-card who-fix-card-${globalIndex + 1}`}
      >
        <div className="who-fix-card-frame">
          <img
            className="who-fix-card-image"
            src={item.image}
            alt={`${item.title} ${item.subtitle}`}
          />
          <div className="who-fix-card-shade" />
          <div className="who-fix-card-grid" />
          <div className="who-fix-card-number">0{globalIndex + 1}</div>
          <div className="who-fix-card-label">
            <strong>{item.title}</strong>
            <small>{item.subtitle}</small>
          </div>
          <div className="who-fix-particles" aria-hidden="true">
            {particles[globalIndex].map((particle, particleIndex) => (
              <i
                key={particleIndex}
                ref={(element) => {
                  if (!particleRefs.current[globalIndex]) {
                    particleRefs.current[globalIndex] = [];
                  }
                  particleRefs.current[globalIndex][particleIndex] = element;
                }}
                style={{
                  width: `${particle.size}px`,
                  height: `${particle.size}px`,
                  opacity: 0,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section ref={sectionRef} id="who-we-are" className="who-fix-section">
      <div className="who-fix-sticky">
        <div className="who-fix-topline">
          <span>WHO WE ARE </span>
          <span>ONE SYSTEM / MANY DISCIPLINES</span>
        </div>

        <div className="who-fix-stage">
          <div className="who-fix-wall who-fix-wall-left">
            {images.slice(0, 3).map((item, index) => renderCard(item, index, "left"))}
          </div>

          <div className="who-fix-center">
            <span className="who-fix-center-kicker">CONNECTED TECHNOLOGY</span>
            <h2>
              Technology<br />
              should feel<br />
              like one system
            </h2>
            <p>
              Techlynx brings engineering, intelligence, infrastructure,
              automation and trust into one connected technology partner.
            </p>
            <div className="who-fix-core">
              <strong>Techlynx</strong>
              <small>Innovation Pvt. Lmt</small>
            </div>
          </div>

          <div className="who-fix-wall who-fix-wall-right">
            {images.slice(3, 6).map((item, index) => renderCard(item, index, "right"))}
          </div>
        </div>

        <div className="who-fix-bottom">
          <span>SCROLL TO EXPLORE</span>
          <div className="who-fix-progress">
            <i style={{ width: "calc(var(--who-progress, 0) * 100%)" }} />
          </div>
          <span>03 / 06</span>
        </div>
      </div>
    </section>
  );
}

const industryProfiles = [
  { name:"IT & Technology", code:"TECH", index:"01", statement:"Build digital products that keep pace with change.", detail:"Product engineering, cloud platforms, APIs, AI and automation for technology-led organisations.", tags:["Product Engineering","Cloud","AI","APIs"], metric:"DIGITAL VELOCITY", value:"01" },
  { name:"Healthcare", code:"HLTH", index:"02", statement:"Connect people, information and intelligent workflows.", detail:"Secure digital experiences, data systems, automation and analytics designed around complex healthcare workflows.", tags:["Data","Automation","Security","Analytics"], metric:"CONNECTED CARE", value:"02" },
  { name:"Education", code:"EDU", index:"03", statement:"Turn learning journeys into connected digital experiences.", detail:"Learning platforms, portals, analytics, mobile experiences and AI-enabled education workflows.", tags:["Platforms","Mobile","AI","BI"], metric:"LEARNING SYSTEMS", value:"03" },
  { name:"Finance", code:"FIN", index:"04", statement:"Engineer for trust, scale and measurable decisions.", detail:"Secure applications, analytics, automation and integration for data-sensitive financial environments.", tags:["Security","APIs","Automation","BI"], metric:"TRUST + SCALE", value:"04" },
  { name:"Manufacturing", code:"MFG", index:"05", statement:"Make operations visible, connected and intelligent.", detail:"Industrial workflows, dashboards, automation, data pipelines and enterprise integration for modern operations.", tags:["IoT","Automation","ERP","Data"], metric:"OPERATIONAL FLOW", value:"05" },
  { name:"Retail", code:"RTL", index:"06", statement:"Create commerce systems that respond in real time.", detail:"Customer-facing platforms, commerce journeys, analytics, inventory workflows and automation.", tags:["Commerce","Data","Mobile","Automation"], metric:"CUSTOMER SIGNAL", value:"06" },
  { name:"Real Estate", code:"RE", index:"07", statement:"Turn property operations into connected digital journeys.", detail:"Property platforms, lead workflows, dashboards, CRM integration and analytics for teams and customers.", tags:["CRM","Portals","Analytics","Automation"], metric:"PROPERTY FLOW", value:"07" },
  { name:"Legal Services", code:"LEGAL", index:"08", statement:"Transform complex legal workflows into connected digital experiences.", detail:"Secure platforms, document automation, case management, analytics and AI-enabled workflows designed for modern legal organisations.", tags:["Case Management","Automation","AI","Security"], metric:"LEGAL INTELLIGENCE", value:"08" },
  { name:"Hospitality", code:"HOSP", index:"09", statement:"Design service experiences that feel effortless.", detail:"Booking journeys, customer platforms, operations dashboards, automation and integrated digital experiences.", tags:["Experience","CRM","Mobile","BI"], metric:"SERVICE EXPERIENCE", value:"09" },
  { name:"Professional Services", code:"PRO", index:"10", statement:"Turn expertise into scalable digital operations.", detail:"Client portals, workflow automation, CRM, analytics and internal platforms for knowledge-driven organisations.", tags:["CRM","Workflow","Portals","Analytics"], metric:"KNOWLEDGE FLOW", value:"10" },
];

function IndustryExperience({ industry, setIndustry }) {
  const active = industryProfiles[industry];
  const stageRef = useRef(null);
  const pointerFrame = useRef(0);
  const pointerTarget = useRef({x:50,y:50});
  const [pointer, setPointer] = useState({x:50,y:50});
  const onMove = (e) => {
    const r = stageRef.current?.getBoundingClientRect();
    if (!r) return;
    pointerTarget.current = {x:((e.clientX-r.left)/r.width)*100,y:((e.clientY-r.top)/r.height)*100};
    if (!pointerFrame.current) {
      pointerFrame.current = window.requestAnimationFrame(() => {
        pointerFrame.current = 0;
        setPointer(pointerTarget.current);
      });
    }
  };
  return <section id="industries" className="industry-experience section-pad">
    <div className="industry-heading"><Reveal><p className="section-kicker">INDUSTRIES WE SERVE </p></Reveal><Reveal delay={80}><h2>Different worlds, One technology language</h2></Reveal><Reveal delay={150}><p>Techlynx adapts its engineering, intelligence, cloud and automation capabilities to the context of the industry — without losing the system underneath.</p></Reveal></div>
    <div className="industry-command">
      <div className="industry-index">{industryProfiles.map((item,i)=><button key={item.name} className={i===industry?'active':''} onMouseEnter={()=>setIndustry(i)} onFocus={()=>setIndustry(i)} onClick={()=>setIndustry(i)}><span>{item.index}</span><b>{item.name}</b><i>{i===industry?'ACTIVE':'VIEW'}</i></button>)}</div>
      <div ref={stageRef} onMouseMove={onMove} className="industry-canvas" style={{'--mx':`${pointer.x}%`,'--my':`${pointer.y}%`}}>
        <div className="industry-canvas-grid"/>
        <div className="industry-topline"><span>CONTEXT ENGINE / {active.code}</span><span>{active.index} / 10</span></div>
        <div className="industry-giant">{active.code}</div>
        <div className="industry-orbit orbit-a"/><div className="industry-orbit orbit-b"/><div className="industry-orbit orbit-c"/>
        <div className="industry-crosshair"><span/><span/></div>
        <div className="industry-core"><small>TECHLYNX</small><strong>{active.index}</strong><em>{active.metric}</em></div>
        <div className="industry-float-card card-a"><small>CAPABILITY</small><b>{active.tags[0]}</b></div>
        <div className="industry-float-card card-b"><small>SIGNAL</small><b>{active.tags[1]}</b></div>
        <div className="industry-float-card card-c"><small>LAYER</small><b>{active.tags[2]}</b></div>
        <div className="industry-float-card card-d"><small>OUTCOME</small><b>{active.tags[3]}</b></div>
        <div className="industry-pointer-dot"/>
        <div className="industry-caption"><span>{active.name}</span><strong>{active.statement}</strong><p>{active.detail}</p><div>{active.tags.map(tag=><b key={tag}>{tag}</b>)}</div></div>
      </div>
    </div>
  </section>;
}

const ecosystemCategories = [
  { id:'software', label:'SOFTWARE', desc:'Products, platforms and application engineering', nodes:['Java','Python','C#','.NET','JavaScript','TypeScript','React','Angular','Vue','Node.js','Express','MERN','MEAN','REST APIs','GraphQL','HTML5','CSS3','Next.js','React Native','Flutter','Dart'] },
  { id:'ai', label:'AI & DATA', desc:'Intelligence, models, knowledge and decision systems', nodes:['AI','Machine Learning','Deep Learning','GenAI','RAG','NLP','Computer Vision','LLMs','Vector DB','Data Science','Data Engineering','Predictive Analytics','BI','SQL','Power BI','Tableau'] },
  { id:'cloud', label:'CLOUD & DEVOPS', desc:'Infrastructure, delivery, scale and observability', nodes:['AWS','Azure','GCP','DevOps','Docker','Kubernetes','CI/CD','Terraform','Linux','Cloud Architecture','Microservices','Serverless','Monitoring','Git','GitHub'] },
  { id:'security', label:'SECURITY & QA', desc:'Trust, testing, validation and reliability', nodes:['Cyber Security','Application Security','API Security','QA','Automation Testing','Performance Testing','SAST','DAST','Test Strategy','Vulnerability Assessment','Secure SDLC','Reliability'] },
  { id:'enterprise', label:'ENTERPRISE', desc:'Business platforms, automation and transformation', nodes:['CRM','ERP','Salesforce','ServiceNow','RPA','Workflow Automation','Business Process','Enterprise Integration','Digital Transformation','SaaS','Data Governance','Operations'] },
  { id:'design', label:'DESIGN & BUSINESS', desc:'Experience, communication and professional capability', nodes:['UI/UX','Product Design','Design Systems','Prototyping','Branding','Digital Marketing','SEO','Content','Business Analysis','Project Management','Consulting','Professional Services'] },
];
const ecosystemNodes = ecosystemCategories.flatMap((cat, ci) => cat.nodes.map((name, i) => ({name, cat:cat.id, ci, i})));

function TechnologyConstellation() {
  const [active, setActive] = useState('software');
  const [focus, setFocus] = useState(null);
  const [pointer, setPointer] = useState({x:50,y:50});
  const stageRef = useRef(null);
  const category = ecosystemCategories.find(c=>c.id===active) || ecosystemCategories[0];
  const visible = category.nodes;
  const positions = visible.map((_,i)=>{
    const angle = (i / Math.max(visible.length,1)) * Math.PI * 2 - Math.PI/2;
    const radius = 29 + (i%3)*3;
    return { x:50 + Math.cos(angle)*radius, y:50 + Math.sin(angle)*radius*.82 };
  });
  const onMove = e => { const r=stageRef.current?.getBoundingClientRect(); if(!r)return; setPointer({x:((e.clientX-r.left)/r.width)*100,y:((e.clientY-r.top)/r.height)*100}); };
  return <section id="capabilities" className="ecosystem-section section-pad">
    <div className="ecosystem-head">
      <Reveal delay={80}><h2>One ecosystem, countless ways to build</h2></Reveal>
      <Reveal delay={80}><p>Software, intelligence, infrastructure, security, enterprise platforms and business capability — connected through one technology partner.</p></Reveal>
    </div>
    <div className="ecosystem-layout">
      <div className="ecosystem-tabs" role="tablist">
        {ecosystemCategories.map(c=><button key={c.id} className={active===c.id?'active':''} onMouseEnter={()=>{setActive(c.id);setFocus(null)}} onFocus={()=>setActive(c.id)} onClick={()=>{setActive(c.id);setFocus(null)}}><span className="ecosystem-tab-marker" aria-hidden="true"/><b>{c.label}</b><em>{c.nodes.length} tracks</em><FiArrowUpRight/></button>)}
        <div className="ecosystem-total"><strong>98<span>+</span></strong><small>INTEGRATED TECHNOLOGY<br/>& PROFESSIONAL SERVICE DOMAINS</small></div>
      </div>
      <div ref={stageRef} className="ecosystem-stage" onMouseMove={onMove} style={{'--mx':`${pointer.x}%`,'--my':`${pointer.y}%`}}>
        <div className="eco-grid"/><div className="eco-glow"/>
        <div className="eco-cross cross-a"/><div className="eco-cross cross-b"/>
        <svg className="eco-lines" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
          {positions.map((p,i)=><line key={i} x1="50" y1="50" x2={p.x} y2={p.y} className={focus===i?'focused':''}/>)}
        </svg>
        {visible.map((name,i)=>{const p=positions[i]; return <button key={name} className={`eco-node ${focus===i?'focused':''}`} style={{left:`${p.x}%`,top:`${p.y}%`}} onMouseEnter={()=>setFocus(i)} onFocus={()=>setFocus(i)} onClick={()=>setFocus(i)}><i/><span>{name}</span></button>})}
        <div className="eco-core"><div className="eco-core-ring r-a"/><div className="eco-core-ring r-b"/><strong>TIPL</strong><span>TECHNOLOGY<br/>CORE</span><small>{category.label}</small></div>
        <div className="eco-pointer"><span>CURSOR FIELD</span><i/></div>
        <div className="eco-stage-label"><span>{category.label}</span><b>{category.desc}</b></div>
        <div className="eco-count"><b>{String(visible.length).padStart(2,'0')}</b><span>VISIBLE<br/>TRACKS</span></div>
      </div>
    </div>
    <div className="ecosystem-marquee"><div>{ecosystemNodes.concat(ecosystemNodes.slice(0,14)).map((n,i)=><span key={`${n.name}-${i}`}>{n.name}<i aria-hidden="true">•</i></span>)}</div></div>
  </section>;
}


function ProvideExperience() {
  const stories = [
    { number: "01", title: "Software Engineering", eyebrow: "BUILD • SCALE • EVOLVE", description: "We engineer scalable digital products, modern web platforms and intelligent software systems designed around real business needs.", image: "/1.png", tags: ["Web Applications", "Enterprise Software", "Digital Products"] },
    { number: "02", title: "Cloud Infrastructure", eyebrow: "CONNECT • DEPLOY • SCALE", description: "Modern cloud infrastructure designed for performance, reliability, security and seamless application deployment.", image: "/2.png", tags: ["Cloud Architecture", "DevOps", "Deployment"] },
    { number: "03", title: "Artificial Intelligence", eyebrow: "LEARN • PREDICT • AUTOMATE", description: "AI-powered solutions that transform business data into intelligent predictions, recommendations and automated decisions.", image: "/3.png", tags: ["AI Solutions", "Machine Learning", "Intelligent Systems"] },
    { number: "04", title: "Automation Workflow", eyebrow: "STREAMLINE • AUTOMATE • OPTIMIZE", description: "Intelligent automation connects people, applications and processes to eliminate repetitive work and improve efficiency.", image: "/4.png", tags: ["Workflow Automation", "Process Optimization", "Integrations"] },
    { number: "05", title: "Data Intelligence", eyebrow: "COLLECT • ANALYZE • DECIDE", description: "Turn complex data into meaningful insights through analytics, dashboards and intelligent data-driven systems.", image: "/5.png", tags: ["Data Analytics", "Business Intelligence", "Insights"] },
    { number: "06", title: "Security & Trust", eyebrow: "PROTECT • MONITOR • SECURE", description: "Security-focused technology solutions designed to protect applications, infrastructure, data and digital operations.", image: "/6.png", tags: ["Cyber Security", "Data Protection", "Risk Management"] },
  ];

  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((current) => (current + 1) % stories.length);
    }, 2800);
    return () => clearInterval(timer);
  }, [stories.length]);

  const current = stories[active];

  return (
    <section id="what-we-provide" className="provide-fix-section">

      <div className="provide-fix-layout">
        <div className="provide-fix-content">
          <div className="provide-fix-heading">
            <span className="provide-fix-kicker">TECHNOLOGY CAPABILITIES</span>
            <h2>We build technology that <em>moves</em></h2>
            <p>
              From software engineering and cloud infrastructure to AI,
              automation, data intelligence and security — Techlynx connects
              technology capabilities into practical business systems.
            </p>
            <p>
              We turn complex technology into scalable, secure and intelligent solutions that solve real business challenges. By bringing engineering, data and emerging technologies together, we help organizations improve operations, accelerate innovation and build for what’s next.
            </p>
          </div>

          <article className="provide-fix-story" key={current.number}>
            <div className="provide-fix-story-body">
              <span className="provide-fix-eyebrow">{current.eyebrow}</span>
              <div className="provide-fix-story-title">
                <div className="provide-fix-story-number">{current.number}</div>
                <h3>{current.title}</h3>
              </div>
              <p>{current.description}</p>
              {/* <div className="provide-fix-tags">
                {current.tags.map((tag) => <span key={tag}>{tag}</span>)}
              </div> */}
            </div>
          </article>

          <div className="provide-fix-controls">
            {stories.map((story, index) => (
              <button
                key={story.number}
                type="button"
                className={index === active ? "active" : ""}
                onClick={() => setActive(index)}
                aria-label={`Show ${story.title}`}
              >
                <span>{story.number}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="provide-fix-visual">
          <div className="provide-fix-image" key={current.number}>
            <img src={current.image} alt={current.title} />
            <div className="provide-fix-image-shade" />
            <div className="provide-fix-image-grid" />
            <div className="provide-fix-image-top">
              <span>TECHLYNX / CAPABILITY</span>
              <b>{current.number}</b>
            </div>
            <div className="provide-fix-image-caption">
              <span>TECHLYNX INNOVATIONS</span>
              <strong>{current.title}</strong>
            </div>
            <div className="provide-fix-image-corner tl" />
            <div className="provide-fix-image-corner tr" />
            <div className="provide-fix-image-corner bl" />
            <div className="provide-fix-image-corner br" />
          </div>

          <div className="provide-fix-progress">
            <div className="provide-fix-progress-line">
              <i style={{ width: `${((active + 1) / stories.length) * 100}%` }} />
            </div>
            <span>{String(active + 1).padStart(2, "0")} / {String(stories.length).padStart(2, "0")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function ProcessExperience() {
  const [active, setActive] = useState(0);
  const steps = [
    { n:'01', title:'DISCOVER', eyebrow:'SIGNAL / UNDERSTAND', text:'We map the business problem before choosing the technology. Users, workflows, constraints, data and opportunity become one clear signal.', metrics:['USER SIGNAL','BUSINESS CONTEXT','OPPORTUNITY'], visual:'discover' },
    { n:'02', title:'ARCHITECT', eyebrow:'SYSTEM / DESIGN', text:'We turn that signal into an architecture: product experience, APIs, data flows, infrastructure, security and delivery strategy.', metrics:['SYSTEM MAP','DATA FLOW','SECURITY'], visual:'architect' },
    { n:'03', title:'ENGINEER', eyebrow:'BUILD / INTEGRATE', text:'Design, development, integration and testing happen as one engineering loop — from interface to backend, AI, data and automation.', metrics:['BUILD','INTEGRATE','VALIDATE'], visual:'engineer' },
    { n:'04', title:'DEPLOY', eyebrow:'RELEASE / SCALE', text:'We move the system into secure, observable infrastructure with repeatable delivery, performance and reliability in mind.', metrics:['CI / CD','OBSERVE','SCALE'], visual:'deploy' },
    { n:'05', title:'EVOLVE', eyebrow:'LEARN / IMPROVE', text:'The work does not end at launch. Analytics, feedback, automation and continuous improvement keep the system useful.', metrics:['MEASURE','OPTIMISE','EVOLVE'], visual:'evolve' }
  ];
  const s = steps[active];
  return <section className="process-experience section-pad" id="process">
    <div className="process-experience-head"><Reveal delay={80}><h2>From first signal to continuous evolution</h2></Reveal><Reveal delay={140}><p>Scroll the system. Each stage changes the visual language, because building technology is a sequence of decisions — not a checklist.</p></Reveal></div>
    <div className="process-journey">
      <div className="process-index">{steps.map((x,i)=><button key={x.n} className={active===i?'active':''} onMouseEnter={()=>setActive(i)} onFocus={()=>setActive(i)} onClick={()=>setActive(i)}><span>{x.n}</span><i/><b>{x.title}</b></button>)}</div>
      <div className={`process-visual pv-${s.visual}`}>
        <div/><div className="process-noise"/>
        {s.visual==='discover' && <div className="signal-map"><span className="signal-ring sr1"/><span className="signal-ring sr2"/><span className="signal-ring sr3"/><i className="signal-pulse"/><div className="signal-card sc1">USER</div><div className="signal-card sc2">BUSINESS</div><div className="signal-card sc3">DATA</div><div className="signal-card sc4">CONSTRAINT</div></div>}
        {s.visual==='architect' && <div className="architecture-map"><div className="arch-node a1">EXPERIENCE</div><div className="arch-node a2">API</div><div className="arch-node a3">DATA</div><div className="arch-node a4">AI</div><div className="arch-node a5">CLOUD</div><div className="arch-core">SYSTEM</div><svg viewBox="0 0 600 420"><path d="M100 90 L300 210 L500 90 M100 330 L300 210 L500 330 M300 210 L300 90 M300 210 L300 330"/></svg></div>}
        {s.visual==='engineer' && <div className="code-build"><div className="code-window"><span>techlynx://build</span><b>● ● ●</b><pre>{`const product = {\n  experience: 'human',\n  intelligence: 'adaptive',\n  infrastructure: 'scalable'\n};\n\nship(product);`}</pre></div><div className="build-progress"><span>BUILD PIPELINE</span><i/><b>87%</b></div></div>}
        {s.visual==='deploy' && <div className="deploy-map"><div className="deploy-cloud">CLOUD</div><div className="deploy-lane dl1"/><div className="deploy-lane dl2"/><div className="deploy-lane dl3"/><div className="deploy-node dn1">BUILD</div><div className="deploy-node dn2">TEST</div><div className="deploy-node dn3">RELEASE</div><div className="deploy-node dn4">LIVE</div><div className="deploy-packet"/></div>}
        {s.visual==='evolve' && <div className="evolve-loop"><div className="loop-ring"/><div className="loop-core">LEARN</div><div className="loop-label l1">DATA</div><div className="loop-label l2">FEEDBACK</div><div className="loop-label l3">AUTOMATION</div><div className="loop-label l4">IMPROVEMENT</div></div>}
        <div className="process-visual-meta"><span>{s.eyebrow}</span><strong>{s.n}</strong></div>
      </div>
      <div className="process-copy" key={s.n}><span className="process-copy-line"/><p>{s.eyebrow}</p><h3>{s.title}</h3><div className="process-rule"/><span>{s.text}</span><div className="process-metrics">{s.metrics.map(m=><b key={m}>{m}</b>)}</div></div>
    </div>
  </section>;
}



const partnerMarks = [
  { logo: i },
  { logo: al },
  { logo: bi },
  { logo: ca },
  { logo: cap },
  { logo: co },
  { logo: cs },
  { logo: hc },
  { logo: he },
  { logo: hy },
  { logo: inf },
  { logo: kp },
  { logo: kpm },
  { logo: sa },
  { logo: sh },
  { logo: so },
  { logo: tc },
  { logo: te },
  { logo: tr },
  { logo: wn },
  { logo: ya },
  { name: "zensar", logo: ze }
];
const technologyMarks = [
  ["REACT", "FRONTEND"], ["NODE.JS", "BACKEND"], ["PYTHON", "AI / DATA"], ["AWS", "CLOUD"],
  ["MONGODB", "DATABASE"], ["FLUTTER", "MOBILE"], ["DOCKER", "DEVOPS"], ["SQL", "DATA"],
  [".NET", "ENTERPRISE"], ["JAVA", "PLATFORM"], ["RAG", "GEN AI"], ["NLP", "INTELLIGENCE"]
];

function ClientTechnologyExperience() {
  const [focus, setFocus] = useState(-1);
  const [techFocus, setTechFocus] = useState(0);
  return <>
    <section className="trust-section section-pad" id="clients">
      <div className="trust-heading">
        <div className="trust-title-row">
          <Reveal delay={80}><h2>Better technology, <span>built together</span></h2></Reveal>
        </div>
        <div className="trust-description">
          <p>Strong partnerships turn technology into progress. We work alongside clients to understand their goals, untangle complex challenges, and deliver reliable digital solutions—from software and AI to cloud and automation. Through clear collaboration and continuous improvement, we help teams move forward with confidence and build for what comes next.</p>
        </div>
      </div>
      <div className="trust-marquee" onMouseLeave={()=>setFocus(1)}>
        <div className="trust-track trust-track-right">{partnerMarks.map((partner,i)=><button key={`right-${i}`} className={focus===i?'focused':''} onMouseEnter={()=>setFocus(i)} onFocus={()=>setFocus(i)} aria-label={partner.name || `Client logo ${i + 1}`}><img className="trust-company-logo" src={partner.logo} alt="" aria-hidden="true"/></button>)}</div>
      </div>
      {/*<div className="trust-bottom"><span>TRUST IS A SYSTEM</span><div/><span>01—08</span></div>*/}
    </section>

    {/*<section className="stack-section section-pad" id="stack">
      <div className="stack-header"><Reveal><p className="section-kicker">TOOLS + TECHNOLOGIES</p></Reveal><Reveal delay={8}><h1>We choose the stack around the <span>system</span></h1></Reveal><Reveal delay={50}><p id="pp">The technology portfolio spans software development, AI and data, cloud and DevOps, testing and security, enterprise technology, design and business services. The stack is a means to the outcome — not the outcome itself.</p></Reveal></div>
      <div className="stack-stage">
        <div className="stack-grid"/>
        <div className="stack-beam beam-a"/><div className="stack-beam beam-b"/>
        <div className="stack-core"><small>TECHLYNX</small><strong>{technologyMarks[techFocus][0]}</strong><span>{technologyMarks[techFocus][1]}</span></div>
        <div className="stack-orbit so-a"/><div className="stack-orbit so-b"/><div className="stack-orbit so-c"/>
        <div className="stack-radial">
          {technologyMarks.map(([name,group],i)=><button key={name} className={`stack-chip sc-${i} ${techFocus===i?'active':''}`} onMouseEnter={()=>setTechFocus(i)} onFocus={()=>setTechFocus(i)} onClick={()=>setTechFocus(i)}><span>{String(i+1).padStart(2,'0')}</span><b>{name}</b><small>{group}</small></button>)}
        </div>
      </div>
      <div className="stack-footer"><span>SELECT A TECHNOLOGY</span><b>{String(techFocus+1).padStart(2,'0')} / {String(technologyMarks.length).padStart(2,'0')}</b><span>{technologyMarks[techFocus][1]}</span></div>
    </section>*/}
  </>;
}


const insightStories = [
  {n:'01', tag:'AI / SYSTEMS', title:'The next interface is intelligence.', text:'AI is moving beyond isolated experiments into products, workflows and decision systems that can understand context and act with people.', signal:'INTELLIGENCE', read:'05 MIN'},
  {n:'02', tag:'ENGINEERING / SCALE', title:'Designing software for the moment after launch.', text:'Scalable products are shaped by architecture, observability, testing, security and the discipline to evolve without losing reliability.', signal:'RESILIENCE', read:'06 MIN'},
  {n:'03', tag:'DATA / DECISIONS', title:'Turn the data layer into a decision layer.', text:'Data becomes valuable when pipelines, analytics, BI and automation connect information to the decisions a business makes every day.', signal:'DECISION', read:'04 MIN'},
  {n:'04', tag:'CLOUD / DELIVERY', title:'Infrastructure should disappear into the experience.', text:'Cloud and DevOps are most powerful when delivery becomes repeatable, measurable and quietly dependable for the teams using it.', signal:'DELIVERY', read:'05 MIN'}
];

function InsightsExperience(){
  const [active,setActive]=useState(0);
  const story=insightStories[active];
  return <section id="insights" className="insights-experience section-pad">
    <div className="insights-intro"><Reveal><p className="section-kicker">INSIGHTS / SIGNALS</p></Reveal><Reveal delay={80}><h2>Ideas that become <span>systems</span></h2></Reveal><Reveal delay={150}><p>Short perspectives from the intersection of software, intelligence, data and digital transformation — built to make complex technology easier to think about.</p></Reveal></div>
    <div className="insights-console">
      <aside className="insights-index">{insightStories.map((x,i)=><button key={x.n} className={active===i?'active':''} onMouseEnter={()=>setActive(i)} onFocus={()=>setActive(i)} onClick={()=>setActive(i)}><span>{x.n}</span><b>{x.tag}</b><i>{active===i?'OPEN':'VIEW'}</i></button>)}</aside>
      <article className="insight-feature" key={story.n}>
        <div className="insight-signal"><div className="signal-grid"/><div className="signal-axis axis-x"/><div className="signal-axis axis-y"/><div className="signal-orbit io-a"/><div className="signal-orbit io-b"/><div className="signal-orbit io-c"/><div className="signal-core"><small>TIPL / SIGNAL</small><strong>{story.signal}</strong><span>{story.n} / 04</span></div><div className="signal-readout"><span>READ TIME</span><b>{story.read}</b></div></div>
        <div className="insight-copy"><div className="insight-meta"><span>{story.n}</span><i/ ><small>{story.tag}</small></div><h3>{story.title}</h3><p>{story.text}</p><a href="#contact">Explore the idea <FiArrowUpRight/></a><div className="insight-footer"><span>TECHLYNX / FIELD NOTE</span><b>0{active+1} — 0{insightStories.length}</b></div></div>
      </article>
    </div>
  </section>;
}

const caseStudies = [
  {id:'01', type:'INTELLIGENT OPERATIONS', title:'A connected command layer for complex operations.', desc:'A concept system that brings workflows, data, automation and AI-assisted decision support into one operational surface.', challenge:'Fragmented workflows and disconnected operational signals.', solution:'Unified interfaces, APIs, data pipelines, automation and intelligence layers.', impact:['CONNECTED WORKFLOWS','REAL-TIME SIGNALS','AI-ASSISTED DECISIONS'], stack:['React','Node.js','Python','SQL','Cloud'], theme:'ops'},
  {id:'02', type:'DIGITAL PRODUCT', title:'From product idea to a scalable digital system.', desc:'Experience-led product architecture combining frontend, backend, APIs, data and cloud delivery around one user journey.', challenge:'Turning a product concept into a reliable, scalable experience.', solution:'Designed the experience, service architecture, API layer and deployment path as one system.', impact:['PRODUCT EXPERIENCE','API ARCHITECTURE','CLOUD READY'], stack:['React','Node.js','REST APIs','Docker','AWS'], theme:'product'},
  {id:'03', type:'AI KNOWLEDGE SYSTEM', title:'Make organisational knowledge searchable, useful and actionable.', desc:'A conceptual RAG-driven intelligence layer that connects documents, structured data and business questions.', challenge:'Knowledge spread across documents, systems and disconnected teams.', solution:'Retrieval, vector search, model orchestration and a focused decision interface.', impact:['RAG PIPELINE','VECTOR SEARCH','DECISION SUPPORT'], stack:['Python','RAG','Vector DB','LLMs','APIs'], theme:'ai'}
];

function WorkExperience() {
  const [active, setActive] = useState(0);
  const c = caseStudies[active];
  return <section id="work" className="work-experience section-pad">
    <div className="work-experience-head">
      <Reveal delay={80}><h2>Don't just show the project, show the thinking</h2></Reveal>
      <Reveal delay={150}><p>We frame every solution around the problem, the system behind it and the outcome it is designed to create.</p></Reveal>
    </div>
    <div className="case-nav">{caseStudies.map((x,i)=><button key={x.id} className={i===active?'active':''} onMouseEnter={()=>setActive(i)} onFocus={()=>setActive(i)} onClick={()=>setActive(i)}><span>{x.id}</span><b>{x.type}</b><i>{i===active?'VIEWING':'OPEN'}</i></button>)}</div>
    <article className={`case-stage case-${c.theme}`} key={c.id}>
      <div className="case-stage-bg"><div className="case-grid"/><div className="case-horizon"/></div>
      <div className="case-visual">
        {c.theme==='ops' && <><div className="ops-core">OOPS<span>CORE</span></div>{['ORDERS','PEOPLE','DATA','WORKFLOW','AI'].map((x,i)=><div className={`ops-node on-${i}`} key={x}>{x}</div>)}<div className="ops-ring r1"/><div className="ops-ring r2"/><svg viewBox="0 0 700 500" className="case-connections">{[0,1,2,3,4].map(i=><line key={i} x1="350" y1="250" x2={120+i*120} y2={80+(i%2)*320}/>)}</svg></>}
        {c.theme==='product' && <><div className="product-window"><div className="window-top"><span/><span/><span/><b>product://experience</b></div><div className="product-layout"><div/><div/><div/><div/><div/></div></div><div className="product-orbit po1"/><div className="product-orbit po2"/><div className="product-core">DX</div></>}
        {c.theme==='ai' && <><div className="ai-core">AI<span>KNOWLEDGE</span></div>{['DOCS','VECTOR','RETRIEVE','MODEL','ANSWER','DATA'].map((x,i)=><div className={`knowledge-node kn-${i}`} key={x}>{x}</div>)}<div className="knowledge-ring kr1"/><div className="knowledge-ring kr2"/></>}
      </div>
      <div className="case-copy" key={c.id}>
        <div className="case-label"><span>{c.id}</span><small>{c.type}</small></div>
        <h3>{c.title}</h3><p>{c.desc}</p>
        <div className="case-columns"><div><small>CHALLENGE</small><b>{c.challenge}</b></div><div><small>SOLUTION</small><b>{c.solution}</b></div></div>
        <div className="case-impact"><small>DESIGNED IMPACT</small>{c.impact.map(x=><b key={x}>{x}</b>)}</div>
        <div className="case-stack">{c.stack.map(x=><span key={x}>{x}</span>)}</div>
        <Link to="/contact" className="case-link">Discuss a similar system <FiArrowUpRight/></Link>
      </div>
    </article>
    <div className="case-progress"><span style={{width:`${((active+1)/caseStudies.length)*100}%`}}/></div>
  </section>;
}


function FAQExperience() {
  const [active, setActive] = useState(0);
  const questions = faqs.map(([q,a], i) => ({
    id: `0${i+1}`,
    q,
    a,
    code: ['BRIEF','BUILD','GLOBAL','STACK','CONNECT','CARE','START'][i] || 'QUERY'
  }));
  const item = questions[active] || questions[0];
  return <section className="faq-command section-pad" id="faq">
    <div className="faq-command-head">
      <div><p className="section-kicker">FAQ / COMMAND CENTER</p><h2>Questions in, <span>clarity out</span></h2></div>
      <p>Select a question. The interface changes state, but the answer stays simple.</p>
    </div>
    <div className="faq-command-grid">
      <div className="faq-command-list">
        {questions.map((x,i)=><button key={x.id} className={i===active?'active':''} onMouseEnter={()=>setActive(i)} onFocus={()=>setActive(i)} onClick={()=>setActive(i)}>
          <span>{x.id}</span><b>{x.q}</b><i>{i===active?'ACTIVE':'OPEN'}</i>
        </button>)}
      </div>
      <article className="faq-command-stage" key={item.id}>
        <div className="faq-radar"><div className="faq-cross x"/><div className="faq-cross y"/><div className="faq-ring fr1"/><div className="faq-ring fr2"/><div className="faq-ring fr3"/><div className="faq-core"><small>TIPL / {item.code}</small><strong>{item.id}</strong><span>ANSWER READY</span></div><div className="faq-ping p1"/><div className="faq-ping p2"/></div>
        <div className="faq-command-copy"><div className="faq-meta"><span>QUERY {item.id}</span><small>{item.code}</small></div><h3>{item.q}</h3><p>{item.a}</p><div className="faq-status"><span><i/> RESPONSE VERIFIED</span><b>{String(active+1).padStart(2,'0')} / {String(questions.length).padStart(2,'0')}</b></div></div>
      </article>
    </div>
  </section>;
}


function ContactExperience() {
  const [submitted, setSubmitted] = useState(false);
  const [type, setType] = useState('DIGITAL PRODUCT');
  const [form, setForm] = useState({name:'', email:'', company:'', brief:''});
  const update=(key,value)=>setForm(v=>({...v,[key]:value}));
  const submit=(e)=>{e.preventDefault();setSubmitted(true);};
  return <section id="contact" className="contact-experience section-pad">
    <div className="contact-command-bg"><div/><div/><div/></div>
    <div className="contact-intro"><Reveal delay={80}><h2>Bring the problem,<br/><span>We'll map the system</span></h2></Reveal><Reveal delay={150}><p>Tell us what you are trying to build, improve or automate. This first step is deliberately simple — enough signal to start the right conversation.</p></Reveal><div className="contact-status"><i/> INTAKE CHANNEL <b>OPEN</b></div></div>
    <div className="contact-panel">
      <div className="contact-panel-head"><span>TIPL / PROJECT INTAKE</span><b>01 — 04</b></div>
      {submitted ? <div className="contact-success"><div className="success-core">✓</div><small>BRIEF CAPTURED</small><h3>Your signal is ready.</h3><p>The front-end intake is complete. Connect this form to your preferred email/API/backend when the Techlynx backend is ready.</p><button onClick={()=>setSubmitted(false)}>Send another brief <FiArrowUpRight/></button></div> : <form onSubmit={submit}>
        <div className="contact-fields"><label><span>01 / NAME</span><input required value={form.name} onChange={e=>update('name',e.target.value)} placeholder="Your name"/></label><label><span>02 / EMAIL</span><input required type="email" value={form.email} onChange={e=>update('email',e.target.value)} placeholder="you@company.com"/></label><label><span>03 / COMPANY</span><input value={form.company} onChange={e=>update('company',e.target.value)} placeholder="Company / organisation"/></label></div>
        <fieldset><legend>04 / WHAT ARE WE SOLVING?</legend><div className="contact-types">{['DIGITAL PRODUCT','AI / DATA','CLOUD / DEVOPS','SECURITY / QA','AUTOMATION','OTHER'].map(x=><button type="button" key={x} className={type===x?'active':''} onClick={()=>setType(x)}>{x}</button>)}</div></fieldset>
        <label className="contact-brief"><span>PROJECT SIGNAL</span><textarea required value={form.brief} onChange={e=>update('brief',e.target.value)} placeholder="A few lines about the problem, product, system or outcome..."></textarea></label>
        <div className="contact-submit"><span>NO PERFECT BRIEF REQUIRED</span><button className="button button-primary" type="submit">Transmit project brief <FiArrowUpRight/></button></div>
      </form>}
    </div>
  </section>;
}

function PageProgress(){
  const [progress,setProgress]=useState(0);
  useEffect(()=>{
    let ticking=false;
    const update=()=>{
      const max=document.documentElement.scrollHeight-window.innerHeight;
      setProgress(max>0 ? Math.min(100,Math.max(0,(window.scrollY/max)*100)) : 0);
      ticking=false;
    };
    update();
    const onScroll=()=>{if(!ticking){window.requestAnimationFrame(update);ticking=true;}};
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    return()=>{window.removeEventListener('scroll',onScroll);window.removeEventListener('resize',update);};
  },[]);
  return <div className="tlx-page-progress" aria-hidden="true" style={{"--scroll-progress":`${progress}%`}}><i/></div>;
}

export default function Home() {
  const [industry, setIndustry] = useState(0); const [slide, setSlide] = useState(0);
  return <div id="home" className="site-shell"><PageProgress />
    <div className="noise" />
    <div className="site-space-bg" aria-hidden="true"><div className="space-stars"/><img className="space-banner" src="/banner.png" alt=""/><img className="space-icon" src="/techlynx-icon.png" alt=""/></div>

    <main>
      {/*<TechlynxHero />*/}

      <HomeVideoCarousel />

      <ProvideExperience />


      <WhoWeAreExperience />

      <AppDevelopmentProcess />

      <TechnologyConstellation />

      {/*}

      <ProcessExperience />

      <IndustryExperience industry={industry} setIndustry={setIndustry} />

      <WorkExperience />

      {/*<TestimonialsExperience active={slide} setActive={setSlide} />*/}

      {/*<InsightsExperience />*/}

      {/*<FAQExperience />*/}

      {/*<ContactExperience />*/}

      <ClientTechnologyExperience />

      <TechlynxBrandEnd />
    </main>

    
  </div>;
}
